<template>
  <div class="initialOrder" :style="`padding-top:${couponCardHeight}px`">
  <!-- <div class="userproductList"  :style="[
        $route.query.tab
          ? { top: '0px' }
          : { top: '127px' },
      ]" style="    background: #f4f6f8;">
      <ul class="navlisttab flx">
      <li @click="tabStatus = 'seller_product'"
        :class="tabStatus === 'seller_product' ? 'selected-tab' : ''">{{$t('yourProducts')}}</li>
      <li @click="tabStatus = 'margin_product'"
        :class="tabStatus === 'margin_product' ? 'selected-tab' : ''">{{$t('mall91SupplyProducts')}}</li>
      </ul>
    </div> -->
      
    <UserProduct v-if="tabStatus === 'seller_product'" @openAddProductOptionModal='openAddProductOptionModal' :couponCardHeight='couponCardHeight' />
    <Mall91SupplyProduct v-if="tabStatus === 'margin_product'" :couponCardHeight='couponCardHeight' />
    <div class="loader" v-if="loading">
      <img src="../../assets/images/loader.gif" alt="loader" />
    </div>
  </div>
</template>

<script>
import '../../assets/css/order-history.scss';
import "../../assets/css/pre-order-detail.scss";
import UserProduct from '@/components/OrderHistorySection/UserProduct'
import Mall91SupplyProduct from '@/components/OrderHistorySection/Mall91SupplyProduct'

// Vue.use(InfiniteLoading);
export default {
  name: 'MyProducts',
  components: {
    UserProduct,
    Mall91SupplyProduct
  },
  data() {
    return {
      tabStatus: 'seller_product',
      loading: false
    };
  },
  props:{
    isActiveMallSupply:{
      type: Boolean
    },
    couponCardHeight:{
      
    }
  },
  methods: {
    openAddProductOptionModal() {
      try {
          JSBridgePlugin.fireEvents("ADD_PRODUCT_CLICK_LMALL");
        } catch (err) {
          console.log(err);
        }
      this.$emit('openAddProductOptionModal');
    },
  },
  mounted() {
    if(this.isActiveMallSupply){
      this.tabStatus = 'margin_product'
    }
  },
};
</script>
<style lang="scss" scoped>
.navlisttab {
      width: 100%;
      height: auto;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .navlisttab li {
      width: auto;
      padding: 8px;
      background: #fff;
      color: #727272;
      border: 1px solid #727272;
      font-size: 14px;
      border-radius: 8px;
      transition: all ease 0.3s;
      position: relative;
    }

    .navlisttab li.selected-tab {
      background: #ff9933;
      border: 1px solid #ff9933;
      color: #fff;
      z-index: 1;
    }

    .navlisttab li:first-child {
      padding-right: 16px;
    }

    .navlisttab li:last-child {
      padding-left: 16px;
    }

    .navlisttab li:first-child.selected-tab {
      padding-right: 8px;
      left: 8px;
    }

    .navlisttab li:last-child.selected-tab {
      padding-left: 8px;
      left: -8px;
    }
.paytm-button {
  border: 0;
  background: none;
  color: #0278ff;
  font-weight: 500;
  font-size: 0.8em;
  text-shadow: 0px 0px 1px #0278ff;
  font-family: 'Roboto', sans-serif;
}
.prod-list {
  // background-color: #ffffff;
  padding: 8px;
  box-shadow: 0 2px 9px 0 rgba(0, 0, 0, 0.08);
  margin: 0 0 8px 0;
  border-radius: 4px;
  &.disable {
    animation: linear fadeout 0.5s 1;
    @keyframes fadeout {
      0% {
        opacity: 1;
      }
      50% {
        height: 0.5;
      }
      100% {
        opacity: 0;
      }
    }
  }
}
.visibilityHidden {
  visibility: hidden;
}
</style>
